/**
 * Ladies Hub Design Tokens - Single Source of Truth
 * Premium curated marketplace theme
 */

export const LadiesHubTheme = {
  colors: {
    // Ladies orange theme
    primary: "#F59E0B",
    primary2: "#FB923C",
    ink: "#111827",
    muted: "#6B7280",
    surface: "#FFFFFF",
    bg: "#FFF7ED",
    chipBg: "rgba(245,158,11,0.10)",
    chipBorder: "rgba(245,158,11,0.25)",
    headerShadow: "rgba(0,0,0,0.08)",
    cardShadow: "rgba(15,23,42,0.12)",
    verified: "#10B981",
    // Dark mode variants
    dark: {
      bg: "#1C1917",
      surface: "#292524",
      ink: "#F5F5F4",
      muted: "#A8A29E",
    }
  },
  
  radii: {
    card: 18,
    chip: 999,
    sheet: 24,
    image: 16
  },
  
  spacing: {
    xs: 6,
    sm: 10,
    md: 14,
    lg: 18,
    xl: 24,
    xxl: 32
  },
  
  shadows: {
    header: "0 8px 20px rgba(0,0,0,0.08)",
    card: "0 12px 28px rgba(15,23,42,0.12)",
    chipBar: "0 10px 30px rgba(15,23,42,0.10)"
  },
  
  motion: {
    spring: { type: "spring", stiffness: 420, damping: 34, mass: 0.9 },
    springSoft: { type: "spring", stiffness: 260, damping: 30, mass: 1.0 },
    fadeSlide: { duration: 0.22, ease: [0.2, 0.8, 0.2, 1] }
  }
};

export default LadiesHubTheme;
